import { createFileRoute } from '@tanstack/react-router'

// The Billing tab's body is rendered by the settings layout, which owns the
// heading and the tab bar. This route exists so the tab is a real destination.
export const Route = createFileRoute('/app/startup/$id/settings/billing')({
  component: () => null,
})
